/*@ngInject*/
module.exports = function($rootScope, $uibModal, classifiersService, publicRoutesService, accessibilityService) {
	return {
		scope: {
			viewMode: '=',
		},
		bindToController: true,
		controllerAs: 'vm',
		controller: function() {
			let vm = this;
			vm.routeGisIds = [];
			vm.isMapView = true;
			vm.showObjects = false;
			vm.mapLoaded = false;
			vm.filter = {category_ids: []};
            vm.showError = false;
            vm.routesLoading = true;
            vm.rootScope = $rootScope;

			accessibilityService.getByPageName('ROUTES').then((res) =>{
				vm.routsInfo = res.data;
			});

			vm.categoryValueChange = function (val) {
				const idx = vm.filter.category_ids.indexOf(val);
				if (idx > -1) {
					vm.filter.category_ids.splice(idx, 1);
				} else {
					vm.filter.category_ids.push(val);
				}
				vm.getRoutesBySearch();
			};

			vm.selectAll = () => {
				if (vm.isAllChecked()) {
					vm.filter.category_ids = [];
				} else {
					vm.filter.category_ids = [];
					angular.forEach(vm.routeCategories, function (cat) {
						vm.filter.category_ids.push(cat.id);
					});
				}
				vm.getRoutesBySearch();
			};

			vm.getRoutesBySearch = function() {
				publicRoutesService.getRoutesBySearch(vm.filter).then(function (result) {
					vm.routesLoading = false;
					vm.routeGisIds = result.data;
                    vm.showError = !vm.routeGisIds || vm.routeGisIds.length === 0;
                });
			};

			vm.$onInit = function () {
				classifiersService.getRouteClassifiers().then(function (response) {
					vm.routeCategories = response.data;

					angular.forEach(vm.routeCategories, function (cat) {
						vm.filter.category_ids.push(cat.id);
					});

					vm.getRoutesBySearch();
				});
			};
//to delete
			vm.openRouteModalTest = (routeId) => {
				publicRoutesService.getRouteDataById(routeId).then((result) => {
					if (result.data !== 'string') {
						vm.selectedObject = result.data;
						$uibModal.open({
							template: require('./search_directives/route-data-modal.html'),
							controller: require('./search_directives/route-data-modal.directive'),
							controllerAs: 'vm',
							size: 'lg',
							backdrop: 'static',
							keyboard: false,
							windowClass: 'center-modal',
							resolve: {
								data () {
									return result.data;
								}
							}
						});
						vm.routeDataModalOpen = true;
						$rootScope.isModalOpen = true;
					}
				});
			};
// end
			vm.isAllChecked = () => {
				if (typeof vm.routeCategories === 'undefined' || typeof vm.filter.category_ids === 'undefined') {
					return true;
				}
				return vm.routeCategories.length === vm.filter.category_ids.length;
			};
		},
		template: require('./route-search.directive.html')
	};
};



/** WEBPACK FOOTER **
 ** ./app/shared/directives/routes/route-search.directive.js
 **/